var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDesktopIcon = function SvgDesktopIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#151414"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.25 18a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5h6.5ZM19.5 5A1.5 1.5 0 0 1 21 6.5v8a1.5 1.5 0 0 1-1.347 1.492L19.5 16h-15l-.153-.008a1.5 1.5 0 0 1-1.34-1.339L3 14.5v-8A1.5 1.5 0 0 1 4.5 5h15Zm-15 9.5h15v-8h-15v8Z"
  }))));
};
export default SvgDesktopIcon;